import React, { useEffect, useState } from "react";
import { Text, Modal, createStyles, Group, Button, Box } from "@mantine/core";
import { MonthPickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import MarViewReportModal from "./MarViewModal";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    overflow: "visible",
    "& .mantine-Modal-content": {
      height: "600px !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  reportInputFields: {
    margin: "auto",
    marginBottom: 10,
    borderBottomColor: "#FFBA4599",
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    paddingBottom: 20,
    display: "flex",
    flexDirection: "row",
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
}));

const AddMarReportModal = ({
  opened,
  onclose,
  title,
  userId,
  selectedClient,
}) => {
  const { classes } = useStyles();
  const [marViewModalOpened, setMarViewModalOpened] = useState(false);

  const form = useForm({
    initialValues: {
      // reportName: "",
      monthValue: [],
      selectedClient: null,
    },
    validate: {
      monthValue: (value) =>
        value.length > 0 ? null : "Please select at least one month.",
    },
  });

  const handleReportClick = (value) => {
    const validationResult = form.validate();
    if (validationResult.hasErrors) {
      return;
    }

    setMarViewModalOpened(true);
  };

  const handleMarViewModalClose = () => {
    setMarViewModalOpened(false);
  };

  const handleClose = () => {
    form.reset();
    onclose();
  };

  useEffect(() => {
    if (userId && opened) {
      form.setFieldValue("selectedClient", userId);
    }
  }, [userId, opened]);

  return (
    <>
      <Modal
        centered
        size={600}
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        className={classes.mymodal}
        title={
          <Group style={{ zIndex: -1 }}>
            <img src="/assets/images/addfac.png" alt="" />
            <Text ff={"Inter"} fw={600} fz={22}>
              {title}
            </Text>
          </Group>
        }
      >
        <form onSubmit={form.onSubmit(handleReportClick)}>
          <Box
            style={{
              border: "1px solid #E0E0E0",
              borderRadius: "5px",
              padding: "10px",
              marginTop: "10px",
            }}
          >
            {selectedClient?.name}
          </Box>
          <MonthPickerInput
            mt={10}
            size="md"
            clearable
            type="range"
            allowSingleDateInRange
            label="Select Months"
            placeholder="Select Months"
            {...form.getInputProps("monthValue")}
          />

          <Box className={classes.viewBtn}>
            <Button color="yellow" c="#000" mt={20} size="md" type="submit">
              View Report
            </Button>
          </Box>
        </form>
      </Modal>
      <MarViewReportModal
        monthValue={form.values.monthValue}
        selectedClient={selectedClient}
        opened={marViewModalOpened}
        onClose={handleMarViewModalClose}
      />
    </>
  );
};

export default AddMarReportModal;
